<dt-step-title [showStepNumber]="false" i18n>Abschlussbetrachtung</dt-step-title>

<dt-step-description>
  <ng-template #description>
    <ng-container i18n>Bewerte, wie entschlossen Du die ermittelte Handlungsalternative umsetzen wirst.</ng-container>
  </ng-template>
  <ng-template #subDescription>
    <ng-container i18n
      >Falls Du alle sechs Kriterien bewertet hast und die Gesamtqualität noch nicht ausreichend ist, reflektiere bitte noch einmal Deine
      Analysen in dem Kriterium, was am schlechtesten bewertet wurde.</ng-container
    >
  </ng-template>
</dt-step-description>

<dt-decision-quality-chart [allowRevise]="true"> </dt-decision-quality-chart>

<ng-template #helpContent1Educational>
  <div class="dt-help-padding">
    <p i18n
      >Auf dieser Seite findest Du eine Übersicht, wie Du die Qualität in Deinen Schritten jeweils eingeschätzt hast. Hast Du dies bisher
      nicht (überall) gemacht, kannst Du an dieser Stelle noch überall die Qualität mithilfe der Buttons im Diagramm bewerten. Wenn Du auf
      die Balken klickst, kannst Du Deine Eingaben noch einmal verändern.</p
    >
    <p i18n
      >An dieser Stelle solltest Du noch das sechste Qualitätskriterium bewerten, die Entschlossenheit der Umsetzung. Hier gibst Du an, wie
      entschlossen Du bist, Deine Entscheidungsempfehlung aus dem Entscheidungsnavi tatsächlich umzusetzen.</p
    >
    <p i18n
      >Sobald Du alle sechs Qualitätskriterien bewertet hast, wird Dir die Gesamtqualität der Entscheidung im obersten Balken angezeigt. Die
      Länge des Balkens und damit die Gesamtqualität orientiert sich immer an dem Schritt, der die niedrigste Bewertung von Dir erhalten
      hat.</p
    >
    <p i18n
      >Diese Übersicht über die Entscheidungsqualität kannst Du jederzeit auch aufrufen, wenn Du auf den Infobutton oben in der Kopfleiste
      klickst.</p
    >
    <p i18n
      >An dieser Stelle hast Du unten in der Navigationsleiste die Möglichkeit, Dein Projekt als JSON-Datei zu exportieren sowie PDF- und
      Excel-Exporte Deines Projekts herunterzuladen. Im PDF-Report wird ein PDF Textdokument Deines Projekts erstellt, also eine textliche
      Zusammenfassung Deines Projekts inkl. alle Deiner getätigten Eingaben und Kommentare. Du kannst zwischen einer kurzen und einer
      ausführlichen Version wählen. Beim Excel-Export wird Dein Wirkungsmodell unter Berücksichtigung Deiner Nutzenfunktionen in eine
      Excel-Datei überführt.</p
    >
    <p i18n
      >Wir hoffen, dass Dir die Arbeit mit dem Entscheidungsnavi Spaß gemacht hat! Wir würden uns über Dein Feedback freuen! Wenn Du uns bei
      der Erforschung von Entscheidungsverhalten und bei der Weiterentwicklung des Tools unterstützen willst, registriere Dich und speichere
      das Projekt in Deinem Account. Deine Projektdaten fließen dann in anonymisierter Form in unsere wissenschaftlichen Studien ein.</p
    >
  </div>
</ng-template>

<ng-template #helpContent2Educational>
  <div class="dt-help-padding">
    <p i18n
      >Nachdem Du alle fünf Schritte des Entscheidungsnavis durchgearbeitet hast, liegt es nun an Dir, Deine Entscheidung zu vollenden und
      in die Tat umzusetzen. Damit Du genau diesen Willen und die Überzeugung zur Umsetzung entwickeln kannst, solltest Du auch wirklich
      hinter der Alternative stehen, die Dir zur Umsetzung vom Entscheidungsnavi empfohlen wird. Ist dies nicht der Fall, solltest Du Dein
      Projekt noch einmal reflektieren und an manchen Stellen ggf. nacharbeiten.</p
    >
    <p i18n
      >Du solltest in allen Schritten so gründlich gearbeitet haben, dass Du überall mindestens eine Qualität von acht vergeben kannst.
      Sollte dies nicht überall der Fall sein, gehe in die entsprechenden Schritte zurück und arbeite Dein Projekt nach, um die Qualität
      Deiner Ergebnisse zu verbessern. Die Gesamtqualität Deiner Entscheidung entspricht immer der niedrigsten aller Bewertungen, also ist
      die Entscheidung immer nur so gut wie der qualitativ schwächste Schritt. Schließlich hilft es zum Beispiel nicht, wenn Du alle
      Schritte gut bearbeitet hast, aber das falsche Entscheidungsproblem löst. Oder wenn Du Deine Ziele sauber aufgearbeitet, aber keine
      guten Alternativen entwickelt hast. Um Deine Entscheidungsqualität noch zu verbessern, beschäftige Dich also zuerst erneut mit dem
      schwächsten Schritt und investiere dort etwas mehr Aufwand.</p
    >
  </div>
</ng-template>
